import * as firebase from 'firebase/app'
import _ from 'lodash'
import urlParse from 'url-parse';
import {tryCall, getThreeDecimals} from "../utils";
import runtime from "../utils/runtime";
import storage from "../utils/storage";
import { transport } from '../transport';
import { getDeviceLevel } from '../utils/device';
import { getRouteName, getUrl } from '../utils/path';
import { checkCompat } from '../compatibility';
import { FIREBASE_ENDPOINT_NAME, PROMETHEUS_ENDPOINT_NAME } from '../constants';

const TDigest = require('tdigest').TDigest;

const digest = new TDigest();

const timeList = []
const N = 10   //阀值

const LAG_FLAG = 100 //ms

const LOCAL_STORAGE_NAME = 'LOCAL_STORAGE_ACTION_3ef705fd12'

let metrics


//初始化进来
export function init() {
    tryCall(() => clickMonitor(), false)

    // 初始化检查数据
    checkLocalStorageData()

    //离开页面检查数据
    window.addEventListener("beforeunload", () => {
        if (metrics) {
            storage.set({key: LOCAL_STORAGE_NAME, metrics, url: getUrl()})
        }
    });
}

//路由变化进来
export function whenRouterChange() {
    // API 兼容性检查
    if (!window.performance || !window.localStorage) {
        return false
    }

    checkLocalStorageData()
}


function clickMonitor() {
    window.addEventListener(
        'ontouchstart' in window ? 'touchstart' : 'click',
        function (e) {
            const diffTime = (performance.now ? performance.now() : Date.now()) - e.timeStamp
            timeList.push(diffTime)

            if (timeList.length === N) {
                const X = timeList.splice(0, N).sort()
                const count = X.filter(i => i > LAG_FLAG).length
                digest.push(X)
                digest.compress()
                metrics = {
                    count,
                    lag_precent: getThreeDecimals(count / X.length),
                    response_50: getThreeDecimals(digest.percentile(0.5)),
                    response_90: getThreeDecimals(digest.percentile(0.9)),
                    response_95: getThreeDecimals(digest.percentile(0.95)),
                    response_99: getThreeDecimals(digest.percentile(0.99)),
                }
            }
        },
        true
    )
    return true
}


function checkLocalStorageData() {
    const storageDataStr = storage.get({key: LOCAL_STORAGE_NAME})

    if (storageDataStr) {
        const data = JSON.parse(storageDataStr)
        record(data)
        storage.clear({key: LOCAL_STORAGE_NAME})
    }

    //路由切换是可以拿到当前页面的数据
    if (metrics) {
        // storage.set({key: LOCAL_STORAGE_NAME, metrics, pathname: window.location.pathname})
        record({
            metrics,
        })
    }
}

function record({ metrics, url }) {
    let pathname;
    if (url) {
        pathname = urlParse(url).pathname;
    }
    transport({
        endPoints: [FIREBASE_ENDPOINT_NAME, PROMETHEUS_ENDPOINT_NAME],
        type: 'action',
        url,
        traceName: `action_${getRouteName(pathname)}`,
        message: {
            metrics: {
                duration: metrics.response_50,
                ..._.pick(metrics, ['response_90', 'response_95', 'response_99', 'lag_precent']),
            },
            attributes: {
                device_level: getDeviceLevel(),
            },
        },
    });
}
